<template>
	<span class="emptyValue" v-if="!value && !value?._cn">{{ $t('model.empty') }}</span>
	<span v-if="value && !value._cn"><component :is="{template: '<span>' + value + '</span>'}"></component></span>
	<component v-if="value && value._cn" :is="value._cn" v-bind="value._cp" />
</template>

<script>
export default {
	name: 'BlStandaloneView',
	props: ['value']
}
</script>

<style scoped lang="scss">
	.emptyValue {
		background-color: var(--bl-background);
		border-radius: var(--bl-border-radius);
		color: var(--bl-legend);
		font-size: 12px;
		padding: 2px 5px;
	}
</style>